import React from "react";

import Button from "../../toolkit/ButtonV1";
import Label from "../../toolkit/Label";
import BarChartIcon from "../../icons/BarChartIcon";
import baseTheme from "../../themes/baseTheme";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Stack,
  Divider,
} from "@mui/material";

import "../../Localization/i18n";
import { useTranslation } from "react-i18next";
import Status from "../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { useNavigate } from "react-router-dom";
import { getOrgType } from "../../utils/Token";
import { styled } from "@mui/material";

// const { palette } = baseTheme;

export default function VendorGridItem({ status, headers = [], statusRoleMap, ...props }) {
  const { t } = useTranslation();
  const rowPadding = "3px 0";


  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // const open = Boolean(anchorEl);

  const navigate = useNavigate();
  const ViewFinancialAnalytics = () => {
    navigate("/ClientAndAdminViewFinancialAnalytics?pqid=" + props?.prequalificationId + "&clientid=" + props?.clientId + "&vendorId=" + props?.vendorId + "&vname=" + props?.vendorName + "&ID=1");
  }
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      <Box>
        <Box padding={rowPadding}>
          <Stack direction="row" spacing={1}>
            <Tooltip  title={props.vendorName} placement="top" arrow>
              <Typography variant="h6" className="dashboardcontainer_ellipse">
                <a
                  variant="body2"
                  style={{ textDecoration: "none", color: "#2A93DB" }}
                  href={"/vendordetails?pqid=" + props.prequalificationId}
                >
                  {props.vendorName}
                </a>
              </Typography>
            </Tooltip>
          </Stack>
        </Box>

        <Box padding={rowPadding}>
          <Typography variant="body2">
            {t("Dashboard.statusPeriod")}:&thinsp;
            {GetfVDateFormate(props.prequalificationStart)}&thinsp; to &thinsp;{GetfVDateFormate(props.prequalificationFinish)}
          </Typography>
        </Box>
        <Box padding={rowPadding}>
          <Typography variant="body2" >
            {t("Dashboard.riskLevel")}:&thinsp;
            {props.templateCode}
          </Typography>
        </Box>
        <Box padding={rowPadding} hidden={ getOrgType() === "Client"}>
          <Button
            label="Financial Analytics"
            leadingComponent={<BarChartIcon />}
            role="linkBlue"
            sx={{ alignItems: "baseline" }}
            onClick={ViewFinancialAnalytics}
          />
        </Box>
        <Box>
          {/* <Status type={status == "Multiple" ? -1 : props.prequalificationStatusId} /> */}
          <Status typeStatus={props.Status} ChangePq={true} />
        </Box>
      </Box>
    </>
  );
}
